import { estimatedColumnWidth } from "../helpers";
import { formatCurrency, formatDate } from "@/utils/helpers";

export default function getExemptSuplliesSaleColumns() {

  const colArr = [
    {
      label: "Tax Payer TRN",
      columnId: "taxPayerTRN",
      width: estimatedColumnWidth("number"),
      resizable: true,
      value: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Company Name",
      columnId: "companyName",
      width: estimatedColumnWidth("name"),
      resizable: true,
      value: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Tax Invoice/Tax Credit Note No",
      columnId: "invoiceNumber",
      width: estimatedColumnWidth("number"),

      resizable: true,
      value: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Tax Invoice/Tax credit note Date",
      columnId: "invoiceDate",
      width: estimatedColumnWidth("date"),

      resizable: true,
      value: true,
      formatter: (value) => (value ? formatDate(new Date(value)) : "")
    },
    {
      label: "Tax Invoice/Tax credit note Received Date",
      columnId: "receivedDate",
      width: estimatedColumnWidth("date"),

      resizable: true,
      value: true,
      formatter: (value) => (value ? formatDate(new Date(value)) : "")
    },
    {
      label: "Reporting Period From",
      columnId: "periodFrom",
      width: estimatedColumnWidth("date"),

      resizable: true,
      value: true,
      formatter: (value) => (value ? formatDate(new Date(value)) : "")
    },
    {
      label: "Reporting Period To",
      columnId: "periodTo",
      width: estimatedColumnWidth("date"),

      resizable: true,
      value: true,
      formatter: (value) => (value ? formatDate(new Date(value)) : "")
    },
    {
      label: "Tax Invoice/Tax credit note Amount AED (before VAT)",
      columnId: "amount",
      width: estimatedColumnWidth("amount"),

      resizable: true,
      value: true,
      formatter: (value) => formatCurrency(String(value || 0))
    },
    {
      label: "Customer Name",
      columnId: "customerName",
      width: estimatedColumnWidth("name"),

      resizable: true,
      value: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Customer TRN",
      columnId: "customerTRN",
      width: estimatedColumnWidth("number"),

      resizable: true,
      value: true,
      formatter: (value) => String(value || "")
    },
    {
      label: "Clear description of the supply",
      columnId: "description",
      width: estimatedColumnWidth("name"),

      resizable: true,
      value: true,
      formatter: (value) => String(value || "")
    }
  ];
  return colArr;
}
